import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconDocumentExcel = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconDocumentExcel"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.88 0A2.88 2.88 0 0 0 0 2.88v18.24A2.88 2.88 0 0 0 2.88 24h18.24A2.88 2.88 0 0 0 24 21.12V2.88A2.88 2.88 0 0 0 21.12 0zm12.391 16.672c.195-.082.374-.198.528-.344q.45-.383.436-.686a1.16 1.16 0 0 0-.37-.713l-2.545-2.965L15.865 9c.207-.184.34-.438.37-.713q.013-.316-.436-.7a1.6 1.6 0 0 0-.515-.36.54.54 0 0 0-.435.027 1.6 1.6 0 0 0-.462.41l-2.37 2.776-2.369-2.77a1.6 1.6 0 0 0-.462-.41.54.54 0 0 0-.436-.026 1.6 1.6 0 0 0-.514.36 1.03 1.03 0 0 0-.436.7c.03.274.162.528.37.712l2.54 2.958-2.54 2.965a1.16 1.16 0 0 0-.37.713 1.02 1.02 0 0 0 .436.686c.153.146.332.262.528.344a.54.54 0 0 0 .435-.027c.175-.1.328-.235.449-.396l2.369-2.76 2.37 2.76q.19.238.449.396a.54.54 0 0 0 .435.027"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconDocumentExcel);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
